import React from "react"

import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-gist-picks.module.scss"
import isRegion from "../../../helpers/newsletter-region"
import CopyContainer from "../../atoms/copy-container"
import Heading from "../../atoms/heading"

const NewsletterGistPicks = ({ section, country, city, segment, styling }) => (
  <>
    {styling !== "lifestyle" ? (
      <CopyContainer className={styles.intro} content={section._rawIntro} />
    ) : (
      ""
    )}
    <CopyContainer
      className={`${styles.wrapper} ${styles[`wrapper__${styling}`]}`}
    >
      {styling === "lifestyle" && section._rawIntro ? (
        <CopyContainer
          className={styles.intro__lifestyle}
          content={section._rawIntro}
        />
      ) : (
        ""
      )}
      {section.content.map((pick, index) =>
        isRegion(pick, country, city, segment) ? (
          <div
            className={
              styling === "lifestyle"
                ? styles.pick__lifestyle
                : styles.pick__regular
            }
          >
            {styling === "lifestyle" && pick.image ? (
              <Image
                {...pick.image}
                className={styles.image}
                width={100}
                height={100}
              />
            ) : (
              ""
            )}
            {styling === "lifestyle" && section.numbered ? (
              <div className={styles.number}>{index + 1}.</div>
            ) : (
              ""
            )}
            <div className={styles.pick__regular}>
              <Heading level={4}>{pick.title}</Heading>
              <CopyContainer
                bg={styling === "lifestyle" ? "black" : ""}
                content={pick._rawContent}
              />
            </div>
          </div>
        ) : (
          ""
        )
      )}
    </CopyContainer>
  </>
)
export default NewsletterGistPicks

NewsletterGistPicks.propTypes = {
  section: PropTypes.object.isRequired,
  country: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  segment: PropTypes.string.isRequired,
  styling: PropTypes.string,
}

NewsletterGistPicks.defaultProps = {
  styling: "",
}
